import { Component, Input } from '@angular/core';
import { VoyageService } from 'src/app/voyages/services/voyage.service';
import { DownloadVoyageFileQuery, FileDto, GetVoyageFileDirectoryQuery } from 'src/app/web-api-client';

@Component({
  selector: 'app-directory',
  templateUrl: './directory.component.html',
  styleUrls: ['./directory.component.scss']
})
export class DirectoryComponent {
  @Input() id: number;
  @Input() items: FileDto[] = [];
  @Input() path: string;

  expandedFolders: Set<string> = new Set<string>();

  constructor(
    private service: VoyageService
  ) { }

  toggleFolder(path: string): void {
    if (this.expandedFolders.has(path)) {
      this.expandedFolders.delete(path);
    } else {
      this.expandedFolders.add(path);

      let index = path.indexOf('/');
      let newPath = path;


      if (index !== -1) {
        newPath = path.substring(index + 1);
      }

      this.service.directory$(new GetVoyageFileDirectoryQuery({ id: this.id, path: newPath }))
        .subscribe(results => {
          this.items = this.items.map(item => {
            if (item.path === path) {
              item.children = results;
            }
            return item;
          });
        });
    }
  }

  downloadFile(path: string): void {
    this.service.download$(new DownloadVoyageFileQuery({ id: this.id, filePath: path }))
      .subscribe(result => {
        const blob = new Blob([result.data]);
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = path.split('/').pop();
        link.click();
        window.URL.revokeObjectURL(url);
      });
  }
}
